import { Link } from "react-router-dom";

export default function ErrorPage() {
  return (
    <div className="ErrorPage">
      <img alt="maskot_404" src="/maskot_404.png" className="sckoro-img" />
      <p className="home-text">Страница не найдена</p>
      <Link to="/" className="Link-button">
        На главную
      </Link>
    </div>
  );
};